import { useContext } from 'react';

import UserContext from './user.context';

function useUser() {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUser must be used within UserContext');
  }

  return context;
}

export default useUser;